import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    activeWindow: null,
    snapStates: [],
    sidebarCollapsed: false,
};
const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setActiveWindow(state, action) {
            state.activeWindow = action.payload;
        },
        setSnapState(state, action) {
            const { windowPath, snapPosition } = action.payload;
            const existing = state.snapStates.find(s => s.windowPath === windowPath);
            if (existing) {
                existing.snapPosition = snapPosition;
            }
            else {
                state.snapStates.push({ windowPath, snapPosition });
            }
        },
        toggleSidebar(state) {
            state.sidebarCollapsed = !state.sidebarCollapsed;
        },
    },
});
export const { setActiveWindow, setSnapState, toggleSidebar } = uiSlice.actions;
export default uiSlice.reducer;
//# sourceMappingURL=uiSlice.js.map